// Sticky Header

class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  /**
   * Calls when Component is Initialized in DOM
   *
   */
  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
    this.headerBounds = {};
    this.currentScrollTop = 0;

    this.onScrollHandler = this.onScroll.bind(this);
    this.onClickOutsideHandler = this.handleClickOutside.bind(this);
    
    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('header-sticky');
    };

    window.addEventListener('scroll', this.onScrollHandler, false);
    document.addEventListener('click', this.onClickOutsideHandler, true);
    this.announcementBar = document.querySelector('.announcement-bar');
    this.announcementBarHeight = this.announcementBar?.offsetHeight || 0;
    this.setHeaderPosition(this.announcementBarHeight);
    this.createObserver();
  }

  /**
   * Calls when Component is removed from DOM
   *
   */
  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
    document.removeEventListener('click', this.onClickOutsideHandler, true);
  }

  /**
   * To observe Sticky header visibility on User Scroll
   *
   */
  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  handleClickOutside(event) {
  // If click is outside the header and dropdowns
  const isInsideHeader = this.header.contains(event.target);
  const isInsideDropdown = event.target.closest('.dropdown.open') !== null;

  if (!isInsideHeader && !isInsideDropdown) {
    this.closeMenuDropdowns();
  }
}

  /**
   * Window Scroll event
   *
   */
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // console.log(scrollTop, this.currentScrollTop, this.headerBounds.bottom);
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      requestAnimationFrame(this.reveal.bind(this));
    } else if (scrollTop <= this.headerBounds.top) {
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  /**
   * Hide Sticky header
   * Close Menu Drawer / Seach Modal / Cart Drawer
   *
   */
  hide() {
    if (!this.headerIsAlwaysSticky){
      this.header.classList.add('header-hidden', 'header-sticky');
      this.closeSearchModal();
      this.closeMenuDropdowns();
    }    
  
    if (window.scrollY > this.announcementBarHeight) {
      this.setHeaderPosition(0);
    } else {
      this.setHeaderPosition(this.announcementBarHeight);
    }
  }

  /**
   * Show Sticky Header
   *
   */
  reveal() {
    if (!this.headerIsAlwaysSticky) {
      this.header.classList.add('header-sticky', 'animate');
      this.header.classList.remove('header-hidden');
    }
    this.setHeaderPosition(this.announcementBarHeight);
  }

  reset() {
    if (window.scrollY > this.announcementBarHeight) {
      this.setHeaderPosition(0);
    } else {
      this.setHeaderPosition(this.announcementBarHeight);
    }
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('header-hidden', 'header-sticky', 'animate');
  }

  /**
   * Set header position with smooth transition
   * @param {number} position - The top position value in pixels
   */
  setHeaderPosition(position) {
    if (window.innerWidth < 567) {
      if(position > 0) {
        this.announcementBar.style.top = `${this.header.offsetHeight}px`;
      } else {
        this.announcementBar.style.top = `0px`;
      }
    } else {
      this.header.style.top = `${position}px`;
    }
  }

  /**
   * Close Search Modal on Window Scroll
   *
   */
  closeSearchModal() {
    let searchModal = document.querySelector('search-modal') || null;
    if(searchModal == null) return;
    
    if(searchModal.classList.contains('open__modal') && typeof searchModal.close == 'function') searchModal.close(false);
  }

  /**
   * Close Menu Dropdowns
   *
   */
  closeMenuDropdowns() {
    let openDropdowns = Array.from(document.querySelectorAll('.dropdown.open'));
    openDropdowns.forEach((ele) => {
      ele.classList.remove('open');
    });
  }
}
customElements.define('sticky-header', StickyHeader);